
import Loadable from 'app/components/Loadable';
import { lazy } from 'react';


const MyAccount = Loadable(lazy(() => import('./MyAccount')));
const EditEductioAcc = Loadable(lazy(() => import('./EditEductioAcc')));

 const BiodataEdit = Loadable(lazy(() => import('./BiodataEdit')));
 const Experience = Loadable(lazy(() => import('./Experience')));
 const Arthography = Loadable(lazy(() => import('./Arthography')));
 const ApplyJob = Loadable(lazy(() => import('./AppyJob')));
  const MyAccProject = Loadable(lazy(() => import('./MyAccProject')));
  const ProfileView = Loadable(lazy(() => import('./ProfileView')));

  const accountRoutes = [
  { path: '/account/my-profile', element: <MyAccount /> },
    { path: '/account/my-profile/education/:mode/:id', element: <EditEductioAcc /> },

  { path: '/account/my-profile/biodata/:mode', element: <BiodataEdit /> },
    { path: '/account/apply-job/:mode/:id', element: <ApplyJob /> },
  { path: '/account/my-profile/Experience', element: <Experience /> },
  { path: '/account/my-profile/:screenName', element: <Arthography /> },
    { path: '/account/my-profile/view-project/:id', element: <MyAccProject /> },
     { path: '/account/view-profile/:id', element: <ProfileView /> },
];

export default accountRoutes;
